import { useState, useEffect } from "react";
import { Card, CardBody, CardHeader, Col, Table, Input } from "reactstrap";
import PatientsTableBody from "./PatientsTableBody";
import { Btn, H4 } from "../../../AbstractElements";
import ReactPaginate from 'react-paginate';
import { H5 } from "../../../AbstractElements";

interface PatientsTableBodyProps {
  patients: any,
  setPatients: (patients: any) => void
}

const PatientsTable: React.FC<PatientsTableBodyProps> = ({ patients = [], setPatients }) => {

  const [perPage, setPerPage] = useState<number>(5);
  const [patientItems, setPatientItems] = useState<any>([]);
  const [patientOffset, setPatientOffset] = useState(0);
  const [patientPageCount, setPatientPageCount] = useState(0);

  useEffect(() => {
    const endPatientOffset = patientOffset + perPage;
    setPatientItems(
      patients.slice(patientOffset, endPatientOffset)
    )

    setPatientPageCount(Math.ceil(patients.length / perPage))
  }, [perPage, patientOffset, patients])

  const handlePageClick = (event: any) => {
    const newOffset = (event.selected * perPage) % patients.length;
    setPatientOffset(newOffset)
  }

  const handleChangePerPage = (e: any) => {
    setPerPage(parseInt(e.target.value))
  }

  return (
    <Col xl="12" className="">
      <Card>
        <CardHeader className={"card-no-border pb-0"}>
          <div className={`header-top`}>
            <H4>{"Patients List"}</H4>
            {/* <Btn color="primary">New Patient</Btn> */}
          </div>
        </CardHeader>
        <CardBody className="pt-0 projects px-0">
          <div className="dataTables_wrapper">
            <div className="table-responsive theme-scrollbar">
              <Table className="table display dataTable no-footer" id="selling-product">
                <thead>
                  <tr>
                    <th>
                      {"No"}
                    </th>
                    <th>{"First Name"}</th>
                    <th>{"Last Name"}</th>
                    <th>{"Address"}</th>
                    <th>{"Email"}</th>
                    <th>{"Phone number"}</th>
                    <th>{"Type"}</th>
                    <th>{"School"}</th>
                    <th>{"Teacher Email"}</th>
                    <th>{"GP Email"}</th>
                  </tr>
                </thead>
                <PatientsTableBody patients={patientItems} setPatients={setPatients} />
              </Table>
            </div>
            <div className=" d-flex justify-content-end align-items-center pagination-container mt-3" style={{ gap: 16 }}>

              <div className="d-flex align-items-center items-per-page" style={{ gap: 8 }}>
                <H5>Per Page : </H5>
                <Input
                  type="number"
                  value={perPage}
                  onChange={(e: any) => handleChangePerPage(e)}
                  style={{ width: 50, textAlign: 'center' }}
                />
              </div>
              <div className="d-flex align-items-center" style={{ gap: 8 }}>
                <div>
                  <ReactPaginate
                    nextLabel=">"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={2}
                    marginPagesDisplayed={1}
                    pageCount={patientPageCount}
                    previousLabel="<"
                    breakLabel="..."
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item page-item-previous"
                    previousLinkClassName="page-link"
                    nextClassName="page-item page-item-next"
                    nextLinkClassName="page-link"
                    breakClassName="page-item page-item-break"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName="active"
                  />
                </div>
              </div>
            </div>
          </div>
        </CardBody>

      </Card>
    </Col>
  );
};

export default PatientsTable;
